import type {
  IDecimalValueAndUnit,
  IEmployees,
  IFarms,
  IJobStatusChange,
  ISilos,
  ISpreadingJob,
  ISpreadingJobField,
  IVehicles
} from '@/interfaces'
import Base from '../Base'
import { DirectionUnitLabelType, TemperatureUnitLabelType, type JobStatusType } from '@/enum'
import DecimalValueAndUnit from '../DecimalValueAndUnit'

class SpreadingJob extends Base implements ISpreadingJob {
  number: string
  status: JobStatusType
  description: string | null
  scheduleDate: string | null
  preAssessmentTime: string
  spreadingTime: string
  windSpeed: IDecimalValueAndUnit
  windDirection: string | null
  cloudCondition: string | null
  temperature: IDecimalValueAndUnit
  fieldCondition: string | null
  farmId: string | null
  farm: IFarms
  field: ISpreadingJobField | null
  siloId: string | null
  silo: ISilos
  assignedEmployeeId: string | null
  assignedEmployee: IEmployees | null
  assignedVehicleId: string | null
  assignedVehicle: IVehicles | null
  notes: string | null
  completedAt: string | null
  statusChangeHistory: IJobStatusChange | null

  constructor(jobData?: any) {
    super(jobData)
    this.number = jobData?.number ?? null
    this.status = jobData?.status
    this.description = jobData?.description
    this.scheduleDate = jobData?.scheduleDate ?? null
    this.preAssessmentTime = jobData?.preAssessmentTime
    this.spreadingTime = jobData?.spreadingTime
    this.windSpeed =
      jobData?.windSpeed ??
      new DecimalValueAndUnit({ value: 0, unit: DirectionUnitLabelType.MILESPERHR })
    this.windDirection = jobData?.windDirection
    this.cloudCondition = jobData?.cloudCondition
    this.temperature =
      jobData?.temperature ??
      new DecimalValueAndUnit({ value: 0, unit: TemperatureUnitLabelType.CELSIUS })
    this.fieldCondition = jobData?.fieldCondition
    this.farmId = jobData?.farmId ?? null
    this.farm = jobData?.farm
    this.field = jobData?.field ?? null
    this.siloId = jobData?.siloId ?? null
    this.silo = jobData?.silo
    this.assignedEmployeeId = jobData?.assignedEmployeeId ?? null
    this.assignedEmployee = jobData?.assignedEmployee ?? null
    this.assignedVehicleId = jobData?.assignedVehicleId ?? null
    this.assignedVehicle = jobData?.assignedVehicle ?? null
    this.notes = jobData?.notes ?? null
    this.completedAt = jobData?.completedAt ?? null
    this.statusChangeHistory = jobData?.statusChangeHistory ?? null
  }
}

export default SpreadingJob
